// ユーザー管理 API サービス

import axios from 'axios';
import { ChangeEmailRequest, ChangeEmailResponse } from '../types/auth';

class UserService {
  /**
   * APIエラーレスポンスをハンドリング
   */
  private handleAxiosError(error: any): never {
    const errorMessage =
      error.response?.data?.error?.message ||
      error.response?.data?.message ||
      error.message ||
      'APIエラーが発生しました';
    throw new Error(errorMessage);
  }

  /**
   * メールアドレスを変更
   * @param data - 現在のパスワードと新しいメールアドレス
   * @returns 変更結果
   */
  async changeEmail(data: ChangeEmailRequest): Promise<ChangeEmailResponse> {
    try {
      const response = await axios.patch<ChangeEmailResponse>(
        '/api/users/me/email',
        data,
        {
          withCredentials: true, // 明示的に設定
        }
      );

      return response.data;
    } catch (error) {
      this.handleAxiosError(error);
    }
  }
}

export default new UserService();

